import {NgIf} from '@angular/common';
import {Component, inject} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AuthenticationConfigurationService} from '@modules/authentication/core/config/authentication-configuration.service';
import {TranslateModule} from '@ngx-translate/core';
import {SharedTranslateModule} from 'shared/shared-translate.module';

@Component({
    selector: 'app-register-link',
    imports: [
        SharedTranslateModule,
        TranslateModule,
        RouterModule
    ],
    templateUrl: './register-link.component.html',
    styleUrl: './register-link.component.scss'
})
export class RegisterLinkComponent {
    private config = inject(AuthenticationConfigurationService);

    public redirectSignupUrl = this.config.settings.redirectSignup.url;
    public redirectSignupTarget = this.config.settings.redirectSignup.target;
    public isDisplayable = this.config.settings.signup || this.config.settings.selfSignup;
}
